/*
  BDEK "Recently viewed" (sections/bdek-recently-viewed.liquid)
  Remembers product handles in this browser only (localStorage "bdek:recently-viewed", max 12),
  then shows the most recent ones other than this product as BDEK product cards.
*/
(function () {
  var KEY = 'bdek:recently-viewed';
  var MAX = 12;

  function read() {
    try {
      var list = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
    } catch (e) {}
  }

  function init(section) {
    if (section.dataset.bdekRecentReady) return;
    section.dataset.bdekRecentReady = 'true';

    var handle = section.getAttribute('data-handle');
    var limit = parseInt(section.getAttribute('data-limit'), 10) || 4;
    var root = section.getAttribute('data-root') || '/';
    if (root.slice(-1) !== '/') root += '/';

    var list = read().filter(function (h) { return h && h !== handle; });
    var toShow = list.slice(0, limit);
    if (handle) write([handle].concat(list));
    if (!toShow.length || !window.fetch) return;

    Promise.all(toShow.map(function (h) {
      return fetch(root + 'products/' + encodeURIComponent(h) + '?section_id=bdek-product-card-render')
        .then(function (response) { return response.ok && !response.redirected ? response.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (pages) {
      var grid = section.querySelector('[data-bdek-recent-grid]');
      var kept = [];
      pages.forEach(function (html, i) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var item = doc.querySelector('li');
        if (!item) return;
        grid.appendChild(document.importNode(item, true));
        kept.push(toShow[i]);
      });
      // Forget products that no longer exist (archived or deleted)
      var gone = toShow.filter(function (h) { return kept.indexOf(h) === -1; });
      if (gone.length) write(read().filter(function (h) { return gone.indexOf(h) === -1; }));
      if (grid.children.length) section.hidden = false;
    });
  }

  function initAll() {
    document.querySelectorAll('[data-bdek-recent]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
